import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  ChangeDetectorRef
} from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { SwalComponent } from '@sweetalert2/ngx-sweetalert2';
import { forkJoin } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { CommonService } from 'src/app/services/common.service';
import { CodeType } from 'src/app/enums/enum';

@Component({
  selector: 'app-generatefile',
  templateUrl: './generatefile.component.html',
  styleUrls: ['./generatefile.component.scss']
})
export class GeneratefileComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private commonSvc: CommonService
  ) { }
  baseUrl = environment.baseUrl;
  errorMessage = '';
  hasError = false;
  ngOnInit() {
    this.hasError = true;
    this.errorMessage = 'The file is being generated, please wait.';
    this.route.queryParams.subscribe(params => {
      const id = params['id'];
      if (id) {
        this.commonSvc.generateVOMLicense(id).subscribe((response: any) => {
          if (response.status) {
            window.open(
              `${this.baseUrl}/Generate/LicenseVOMFile?id=${response.resultObj}`,
              '_blank'
            );
            this.hasError = true;
            this.errorMessage = 'Generate Sucessful';
          } else {
            this.hasError = true;
            this.errorMessage = response.msg;
            alert(response.msg);
          }
        },
        (err: any) => {
          this.hasError = true;
          this.errorMessage = 'An error occurred. Please contact the system administrator.';
          alert(err.error.exceptionMessage);
        });
      }
    });
    //window.close();
  }
}
